import { bulkActionFactory } from '@core/async-job-data';
import { AsyncJobType } from '@core/async-job-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

import type { Ids } from './bulk-actions-http-client';

const idSelector = ({ uuid }: { uuid: string }) => uuid;
const { actions, namespace, reducer, selectors } = createEntityCollectionStore<{ uuid: string }>()(
  'requisitions-bulk-actions',
  {
    idSelector,
    customActions: adapter => {
      const getActions = bulkActionFactory(adapter);
      return {
        ...getActions('follow', AsyncJobType.BulkRequisitionsFollow)<Ids>(),
        ...getActions('unfollow', AsyncJobType.BulkRequisitionsUnfollow)<Ids>(),
        ...getActions('archive', AsyncJobType.BulkRequisitionsArchive)<Ids>(),
        ...getActions('retrieve', AsyncJobType.BulkRequisitionsRetrieve)<Ids>(),
      };
    },
  },
);

const RequisitionsBulkActions = <
  Pick<
    typeof actions,
    | 'follow'
    | 'followSuccess'
    | 'followFailed'
    | 'unfollow'
    | 'unfollowSuccess'
    | 'unfollowFailed'
    | 'archive'
    | 'archiveSuccess'
    | 'archiveFailed'
    | 'retrieve'
    | 'retrieveSuccess'
    | 'retrieveFailed'
  >
>actions;

export {
  RequisitionsBulkActions,
  selectors as RequisitionsBulkSelectors,
  reducer as RequisitionsBulkReducer,
  namespace as RequisitionsBulkNamespace,
};
